export const examineTab = [
  { label: "期间", value: "yearPeriods", show: "normal", width: 60,isShow:false },
  { label: "审核状态", value: "examineState", show: "template", width: 60,isShow:false },
  { label: "财务情况", value: "accountingState", show: "template",isShow:false, width: 60 },
  { label: "赤字", value: "a", show: "template", showChild: true,
    children: [
      { label: '现金', value: 'cash', show: 'template',isShow:false,sign: true, width: 70},
      { label: '银行', value: 'bank', show: 'template',isShow:false,sign: true, width: 70},
      { label: '原材料', value: 'rawMaterials', show: 'template',isShow:false,sign: true, width: 70},
      { label: '库存商品', value: 'goodsInStock', show: 'template',isShow:false,sign: true, width: 70},
      { label: '长期待摊费用', value: 'deferredExpenses', show: 'template',isShow:false,sign: true, width: 70},
      { label: '固定资产净值', value: 'fixedAssets', show: 'template',isShow:false,sign: true, width: 120},
    ]
  },
  { label: "凭证&报表", value: "b", show: "template", showChild: true,
    children: [
      { label: '凭证断号', value: 'voucherDiscontinuousNumber', show: 'template',isShow:false,sign: true},
      { label: '资产负债表', value: 'assetsLiabilities', show: 'template'},
      { label: '净利润勾稽关系', value: 'netProfit', show: 'template'},
    ]
  },
  { label: "历史问题", value: "problem", show: "template" },
  { label: "操作", value: "operate", show: "template" },
]


// WEBPACK FOOTER //
// ./src/pages/examine/config/tabConfig.js